module.exports = __webpack_public_path__ + "img/51.77c6fd4.jpg";